export enum DOC_TYPE {
  FOLDER = "1",
  FILE = "2",
}
